import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminCacheService {

  constructor(private http: HttpClient) { }

  getKeysWithValues(key: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/cache/keys/detailstartswith/${key}`
      );
  }

  deleteAll(): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/cache/deleteall`
      );
  }

  deleteKey(key: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/cache/delete/${key}`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/admin/admin-cache.service.ts